'use strict'

exports = module.exports = function (doc) {
  if (typeof doc === 'string') return exports({ cookie: doc })
  if (!doc) {
    if (typeof document !== 'undefined') return exports(document)
    else return exports({})
  }
  if (doc.cookie === undefined) return exports({ cookie: '' })

  var methods = {
    key: function (index) {
      var cookies = split(doc.cookie)
      if (cookies[index]) {
        return cookies[index][0]
      }
    },

    getItem: function (key) {
      return map(doc.cookie)[key]
    },

    setItem: function (key, value, options) {
      var format = formattersFor(options)
      doc.cookie = [
        formatters.cookie(key, value),
        format('expires'),
        format('domain'),
        format('path'),
        format('secure')
      ].filter(identity).join('; ')
    },

    removeItem: function (key) {
      methods.setItem(key, undefined, { expires: -Infinity })
    },

    clear: function () {
      while (methods.length) methods.removeItem(methods.key(0))
    }
  }

  Object.defineProperty(methods, 'length', {
    get: function () {
      return split(doc.cookie).length
    }
  })

  return methods
}

// private

function split (cookie) {
  if (!cookie) return []

  return cookie.split(/;\s*/).map(function (c) {
    return c.split('=').map(decodeURIComponent)
  })
}

function map (cookie) {
  return split(cookie).reduce(function (cookies, c) {
    cookies[c[0]] = c[1]
    return cookies
  }, {})
}

var formatters = {
  cookie: function (key, value) {
    return encodeURIComponent(key) + '=' + encodeURIComponent(value)
  },

  domain: function (domain) {
    return 'domain=' + domain
  },

  expires: function (expiration) {
    if (expiration === Infinity) return formatters.expires(8640000000000000)
    if (expiration === -Infinity) return formatters.expires(0)
    return 'expires=' + new Date(expiration).toUTCString()
  },

  path: function (path) {
    return 'path=' + path
  },

  secure: function (secure) {
    if (secure) return 'secure'
  }
}

function formattersFor (options) {
  options = options || {}
  return function format (name) {
    if (options.hasOwnProperty(name)) return formatters[name](options[name])
  }
}

function identity (x) {
  return x
}



//////////////////
// WEBPACK FOOTER
// ./~/cookiestorage/index.js
// module id = 757
// module chunks = 0